// @ vendors
const { Promise } = require('es6-promise');
const { download } = require('utilities/fileDownloadHelper');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const DateHelper = require('utilities/dateHelper');
const { nonNumericFilter } = require('utilities/stringHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
 //@actions
const signaturePatternActions = require('actions/signaturePattern');
// @ constants
const actionTypes = require('constants/actionTypes');
const { CARD_DEBIT, CARD_ECARD } = require('constants/index');

const resetCardDownloadPdf = () => ({
    type: actionTypes.CARD_DOWNLOAD_PDF_RESET
});

const getCardDownloadPdfSuccess = () => ({
    type: actionTypes.CARD_DOWNLOAD_PDF_SUCCESS
});

const getCardDownloadPdfFailure = (error) => ({
    type: actionTypes.CARD_DOWNLOAD_PDF_FAILURE,
    payload: {
        error
    }
});

const getCardDownloadPdf = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {

        const immCard = getState().cards.getIn(['byId', cardId]);
        const typeOfCard = immCard.get('type');
        const cardNumber = nonNumericFilter(immCard.get('number'));
        const expirationDate = DateHelper.buildFormattedDate(immCard.get('expirationDate'), 'MMYY');
        const format = 'PDF';
        const holder = immCard.get('beneficiaryNameOnCard').replace(/\*/g, ' ');
        let url = apiURLBuilder.getURL('getVirtualCardPDF',{ typeOfCard });
        let pdfName = `Virtual${typeOfCard}card_PDF.pdf`;

        if (typeOfCard === CARD_DEBIT){
            const standard = immCard.getIn(['product', 'standard']);

            if (standard === '0000003') {
                url = apiURLBuilder.getURL('getVirtualCardPDF', {typeOfCard: 'DEBIT_PRIDE'});
            } else if (standard === '0000004') {
                url = apiURLBuilder.getURL('getVirtualCardPDF', {typeOfCard: 'DEBIT_BREAST_CANCER'});
            }
        }

        if(typeOfCard === CARD_ECARD){
            url = apiURLBuilder.getURL('getEcardPdf',{ typeOfCard });
            pdfName = `${typeOfCard}_PDF.pdf`;
        }
        const requestData = {
            header: {
                responseType: 'arraybuffer',
                accept: 'application/pdf'
            },
            query: {
                cardNumber,
                dataToken,
                expirationDate,
                format,
                holder
            }
        };
        return APIPost(
            dispatch,
            url,
            requestData
        )
            .then(response => {
                download(response.xhr.response, pdfName, 'application/pdf');
                dispatch(getCardDownloadPdfSuccess(response))
            })
            .catch((response) => {
                if (response.error) {
                    dispatch(getCardDownloadPdfFailure(response.error.description));
                } else {
                    throw response;
                }
            });
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    getCardDownloadPdf,
    resetCardDownloadPdf
}
